import React from 'react';

import { t } from '../../services/i18nService';
import chromeAppService from '../../services/ChromeAppService';
import sessionReader from '../../store/readHelpers/SessionReader';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';

import styles from './options.scss';

class OptionsExitChromeApp extends React.Component {
    exitChromeApp() {
        chromeAppService.exitChromeApp();
    }

    render() {
        const mainButtonText = t('options.exitChromeAppButtonText');

        const requireInvigilatorPassword = sessionReader.testUsesInvigilatorPassword();

        return (
            <div>
                <OptionsTopBar title={t('options.exitChromeApp')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        mainButtonText={mainButtonText}
                        actionHandler={this.exitChromeApp}
                        requireInvigilatorPassword={requireInvigilatorPassword}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsExitChromeApp;
